export default __webpack_public_path__ + "e2217a20d187c37a26dbe23664109180.svg";